import { staticAsset } from './staticAssets.js';

export const HELP_CATEGORY_ICONS = {
  reg: staticAsset('/content/FAQ/icons/reg.png'),
  balance: staticAsset('/content/FAQ/icons/balance.png'),
  pers: staticAsset('/content/FAQ/icons/pers.png'),
  bets: staticAsset('/content/FAQ/icons/bets.png'),
  promo: staticAsset('/content/FAQ/icons/promo.png'),
  tech: staticAsset('/content/FAQ/icons/tech.png'),
  apps: staticAsset('/content/FAQ/icons/apps.png'),
  interface: staticAsset('/content/FAQ/icons/interface.png'),
  strats: staticAsset('/content/FAQ/icons/strats.png'),
  adv: staticAsset('/content/FAQ/icons/adv.png'),
};

export function getHelpCategoryIcon(iconKey) {
  return HELP_CATEGORY_ICONS[iconKey] || null;
}
